
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiViewDashboard,
	mdiAccountAlert,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
    mdiFaceAgent
} from '@mdi/js'
// const roles = localStorage.getItem('roles')
const menuTeacher = [
	'General',
		[
			{
				to: '/home-comboard',
				icon: mdiViewDashboard,
				label: 'sidebar.dashboard'
			}
		],
		'Examples',
		[
            {
				label: 'Permission Request',
				subLabel: 'Submenus Teacher',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/permissions',
						label: 'Permissions',
						icon: mdiFaceAgent
					},
         			{
						to: '/permission-reason',
						label: 'Permission Reason',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Attendance',
				subLabel: 'Submenus Attendance',
				icon: mdiAccountArrowLeft,
				menu: [
					{
						to: '/attendancelist',
						label: 'Regular Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/attendancestreaming',
						label: 'Parallel Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/reportattendancedaily',
						label: 'Daily Attendance Report',
						icon: mdiAccountAlert
					}
				]
			}
		]
]
// console.log('roles menuTeacher', roles)
export default menuTeacher
